<template>
    <span class="d-none">TeamMemberData</span>
</template>
<script>
import axios from 'axios'
export default {
    name: 'TeamMemberData',
    data() {
        return {
            teamMemberOptions: [],
            teamMemberFilterOptions: [],
            teamMemberImgFilterOptions: [],
        }
    },
    async mounted() {
        if (this.$store.state.isActiveToken != '1') {
            // console.log(this.currentDate);
        } else {
            await this.teamMemberDataList();
        }
    },
    computed: {
        iAT() {
            return this.$store.state.user.roleId
        },
    },
    watch: {
        async iAT(newValue) {
            if (this.$store.state.user.roleId != '') {
                await this.teamMemberDataList();
            }
            return newValue
        },
    },
    methods: {
        async teamMemberDataList() {
            if (this.$store.state.isActiveToken == '1' && this.$store.state.teamMember.loadTeamMemberData === 1) {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
                await axios.get(process.env.VUE_APP_API_URL + 'user/active')
                    .then((resp) => {
                        if (resp.status == 200 && resp.data.status == 'success') {
                            const teamMemberOpts = resp.data.data.records
                            this.teamMemberOptions = [];
                            this.teamMemberFilterOptions = [];
                            this.teamMemberImgFilterOptions = [];
                            var len = teamMemberOpts.length;
                            for (var i = 0; i < len; i++) {
                                this.teamMemberOptions.push({
                                    id: teamMemberOpts[i]._id,
                                    text: teamMemberOpts[i].name
                                });
                                this.teamMemberFilterOptions.push({
                                    value: teamMemberOpts[i]._id,
                                    label: teamMemberOpts[i].name
                                });
                                this.teamMemberImgFilterOptions.push({
                                    value: teamMemberOpts[i]._id,
                                    user_image: teamMemberOpts[i].user_image,
                                    initials: teamMemberOpts[i].initials,
                                    label: teamMemberOpts[i].name
                                });
                            }
                            this.$store.state.teamMember.loadTeamMemberData = 2
                            this.$store.state.teamMember.TeamMemberList = this.teamMemberOptions
                            this.$store.state.teamMember.TeamMemberFilterList = this.teamMemberFilterOptions
                            this.$store.state.teamMember.TeamMemberImgFilterList = this.teamMemberImgFilterOptions
                        }
                    })
                    .catch(error => {
                        console.error("There was an error!", error);
                        console.log("response", error.response.status);
                        console.log("message", error.response.data.message);
                    })
            }
        },
    },

}

</script>